import { FC, HTMLAttributes, useState } from 'react'

import { TextPromo } from 'components/ui'
import { Space } from 'components/ui/Space/Space'
import { useResize } from 'utils/hooks/useResize'

import { QAItem } from '../types'

import ArrowIcon from 'assets/img/shared/arrow2.svg?react'
import s from './FaqItem.module.scss'

interface IFaqItem extends HTMLAttributes<HTMLDivElement> {
  question: QAItem
}

export const FaqItem: FC<IFaqItem> = ({ question, ...other }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const { isMobile } = useResize()

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={s.container} {...other}>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleToggle}
        className={s.question}
      >
        <TextPromo
          fontFamily="ASLHauss"
          weight="w500"
          size={!isMobile ? 's32' : 's24'}
          color="default"
          className={isHovered ? s.hovered : ''}
          pointer
        >
          {question.q}
        </TextPromo>
        <TextPromo
          className={`${s.icon} ${isHovered ? s.hovered : ''}`}
          pointer
          fontFamily="ASLHauss"
          weight="w400"
          size="s40"
        >
          {isOpen ? (
            <ArrowIcon className={s.arrow} style={{ transform: 'rotate(180deg)' }} />
          ) : (
            <ArrowIcon className={s.arrow} />
          )}
        </TextPromo>
      </div>
      {isOpen && (
        <>
          <Space size={12} />
          <div
            className={s.answer}
            dangerouslySetInnerHTML={{
              __html: question.a
                .replace(/faqList/g, s.faqList)
                .replace(/item/g, s.item)
                .replace(/colorBox/g, s.colorBox)
                .replace(/icon/g, s.icon)
                .replace(/color1/g, s.color1)
                .replace(/color2/g, s.color2)
                .replace(/color3/g, s.color3)
                .replace(/color4/g, s.color4)
                .replace(/color5/g, s.color5)
                .replace(/color6/g, s.color6),
            }}
          />
        </>
      )}
    </div>
  )
}
